<div class="col-md-12">
    <hr/>
    <label class="form-labels mt-4">¿Hay garantizador?</label><br/>
    <div class="form-check form-check-inline">
        <input (change)="garantizador($event)" class="form-check-input" id="hasGuaranterSi" type="radio" value="si" name="garantizador">
        <label class="form-check-label">Si</label>
    </div>
    <div class="form-check form-check-inline">
        <input (change)="garantizador($event)" class="form-check-input" id="hasGuaranterNo" name="garantizador" type="radio" value="no">
        <label class="form-check-label">No</label>
    </div>
</div>


<div class="col-md-12 mt-4" *ngIf="showGarantizador">
    <hr/>
    <h5>Información del Garantizador</h5>
</div>

<div [formGroup]="form" class="row" id="garantizador" *ngIf="showGarantizador">
    <div class="col-md-6">
        <label class="form-labels mt-4">Nombre</label>
        <div class="input-group">
            <input formControlName="name" type="text" class="form-control">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Seguro Social</label>
        <div class="input-group">
            <input formControlName="ss" type="text" class="form-control" [brmasker]="{mask: '000-00-0000', type:'num'}" maxlength="11">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Número de Licencia</label>
        <div class="input-group">
            <input formControlName="licence" type="text" class="form-control">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Fecha de Nacimiento</label>
        <input formControlName="birthDate" type="date" class="form-control">
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Estado Civil</label>
        <select formControlName="civilStatus" class="form-select">
            <option value="casado">Casado</option>
            <option value="soltero">Soltero</option>
        </select>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Nombre del Cónyuge</label>
        <div class="input-group">
            <input formControlName="spouseName" type="text" class="form-control">
        </div>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Teléfono Conyuge</label>
        <div class="input-group">
            <input formControlName="spousePhone" type="text" class="form-control" [brmasker]="{mask: '(000) 000-0000', type:'num'}" maxlength="14">
        </div>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Número de Dependientes</label>
        <div class="input-group">
            <input type="text" formControlName="dependientes" class="form-control">
        </div>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Pariente</label>
        <div class="input-group">
            <input formControlName="pariente" type="text" class="form-control">
        </div>
    </div>

    <app-address [address]="editGarantizador?.address" (formReady)="addChildForm('address', $event)"></app-address>

    <app-employer-info [employer]="editGarantizador?.employeer" (formReady)="addChildForm('employeer', $event)"></app-employer-info>
</div>